// ==================== ACCOUNT SWITCHER ====================
// Multiple organizations: the header dropdown that scopes every screen to one account
// (or all of them). Only customers with more than one organization see it.

import { Select } from '../ui';
import { useOrganizations } from '../../hooks/useOrganizations';
import { ALL_ORGANIZATIONS, organizationFilterOptions } from './organizationOptions';

export const AccountSwitcher = () => {
  const { organizations, isMultiOrganization, selectedOrganizationId, selectOrganization } = useOrganizations();

  if (!isMultiOrganization) return null;

  return (
    <div className="w-36 sm:w-48">
      <Select
        size="sm"
        options={organizationFilterOptions(organizations)}
        value={selectedOrganizationId ?? ALL_ORGANIZATIONS}
        onChange={(value) => {
          const id = Array.isArray(value) ? value[0] : value;
          selectOrganization(id === ALL_ORGANIZATIONS ? undefined : id);
        }}
      />
    </div>
  );
};
